import React from "react";
import { shape, string } from "prop-types";
import { DATA_SPACER } from "#library/constants/enums";
import { Illustration, ILLUSTRATION_SIZES } from "#library/components/Illustration/Illustration";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import { useModal } from "#library/components/Modal/ModalManagement/ModalContext";
export var ModalSymbol = function ModalSymbol(_ref) {
  var icon = _ref.icon,
    illustration = _ref.illustration;
  var _useModal = useModal(),
    withIllustration = _useModal.withIllustration;
  if (withIllustration) {
    return (illustration === null || illustration === void 0 ? void 0 : illustration.id) && /*#__PURE__*/React.createElement(Illustration, {
      size: ILLUSTRATION_SIZES.SMALL,
      xlinkHref: "#".concat(illustration.id),
      role: "presentation",
      "data-spacer": DATA_SPACER.BOTTOM_300
    });
  }
  return (icon === null || icon === void 0 ? void 0 : icon.id) && /*#__PURE__*/React.createElement(Icon, {
    role: "presentation",
    xlinkHref: "#".concat(icon.id),
    size: ICON_SIZES.LARGE,
    dataSpacer: DATA_SPACER.BOTTOM_150
  });
};
ModalSymbol.propTypes = {
  icon: shape({
    id: string
  }),
  illustration: shape({
    id: string
  })
};
ModalSymbol.defaultProps = {
  icon: {
    id: null
  },
  illustration: {
    id: null
  }
};